<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <location-form
          @submit="submit"
          :init-location="{ location: 'ss' }"
          :val-errors="valErrors"
          submit-text="Erstellen"
        />
      </card>
    </div>
  </div>
</template>

<script>
import LocationForm from './location-form'

export default {
  components: { LocationForm },
  data () {
    return {
      valErrors: []
    }
  },
  methods: {
    async submit (location) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post('locations', location).then(({ data }) => {
        this.$notify({
          message: 'Standort erfolgreich erstellt.',
          type: 'success'
        })
        this.$router.push('/locations')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  }
}
</script>

<style>
</style>
